// src/hooks/useProfileData.ts
import { useEffect, useState, useCallback } from 'react';
import { getAPI } from '../../services/api.service';

export function useProfileData() {
  const [profile, setProfile] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProfile = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const userStr = localStorage.getItem('user');
      const userObj = userStr ? JSON.parse(userStr) : null;
      const userId = userObj?.user?.id ?? userObj?.id ?? null;

      if (!userId) {
        setError('User not found in localStorage');
        setLoading(false);
        return;
      }

      const resp = await getAPI<{ data: any }>('auth/me', { userId });

      if (resp.status === 200 && resp.data) {
        // Accept both shapes: { data: {...} } or directly {...}
        const payload = resp.data?.data ?? resp.data;
        setProfile(payload);
      } else {
        setError(typeof resp.error === 'string' ? resp.error : 'Failed to fetch profile');
      }
    } catch (err: any) {
      setError(err?.message ?? 'Failed to fetch profile');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return { profile, loading, error, refetch: fetchProfile };
}
